import { Loader } from "lucide-react";

/**
 * Shared "Load more" control for the paginated list pages. Renders nothing
 * once the last page has been loaded, so callers can drop it in unguarded.
 */
export default function LoadMore({ hasMore, isLoading, onClick, label = "Load more" }) {
  if (!hasMore) return null;

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "24px 0" }}>
      <button
        type="button"
        onClick={onClick}
        disabled={isLoading}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "10px 24px",
          borderRadius: 10,
          border: "1.5px solid #e5e7eb",
          background: isLoading ? "#f9fafb" : "#fff",
          color: "#374151",
          fontSize: 13,
          fontWeight: 600,
          fontFamily: "'Inter', sans-serif",
          cursor: isLoading ? "not-allowed" : "pointer",
        }}
      >
        {isLoading && (
          <Loader size={14} style={{ animation: "loadmore-spin 1s linear infinite" }} />
        )}
        {isLoading ? "Loading…" : label}
      </button>
      <style>{`@keyframes loadmore-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
